import Splide from "@splidejs/splide";

const cards = document.querySelectorAll(".card-inner");
const dropdownbuttons = document.querySelectorAll(".dropbtn");
function mobile() {
  document.getElementById("mydropdown").classList.toggle("show");
}

// Close the dropdown menu if the user clicks outside of it
window.onclick = function(event) {
  if (!event.target.matches('.dropbtn')) {
    var dropdowns = document.getElementsByClassName("dropdown-content");
    var i;
    for (i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      if (openDropdown.classList.contains('show')) {
        openDropdown.classList.remove('show');
      }
    }
  }
}

cards.forEach((card) => {
  card.addEventListener('click', function (e) {
    this.classList.toggle('is-flipped');
  });
});

dropdownbuttons.forEach((button) => {
  button.addEventListener('click', mobile);
});

new Splide('#image-carousel-1').mount();

const openDetailsIfAnchorHidden = evt => {
  const targetDIV = document.querySelector(evt.target.getAttribute("href"));
  if ( !! targetDIV.offsetHeight || targetDIV.getClientRects().length ) return;
  targetDIV.closest("details").open = true;
}


[...document.querySelectorAll("[href^='#']")].forEach(
    el => el.addEventListener("click", openDetailsIfAnchorHidden )
);

const elementsToFadeInUpOnScroll = document.querySelectorAll(".fade-in");
if (elementsToFadeInUpOnScroll) {
  window.addEventListener("scroll", function(event) {
    elementsToFadeInUpOnScroll.forEach(function(element) {
      if (window.scrollY >= (element.offsetTop - window.innerHeight)) {
        element.classList.add("fade-in-up");
      } else {
        element.classList.remove("fade-in-up");
      }
    });
  });
}








